import React, { useEffect, useRef, useState } from 'react';
import { loadGoogleMapsScript } from '../../utils/loadGoogleMapsScript';
import "./location-picker.shared.scss";
import { FormControl, TextField } from '@mui/material';
interface LocationPickerProps {
    apiKey: string;
    formList: any;
    isSubmit: boolean;
    handleAddressChange(value): void;
    onLocationChange: (lat: number, lng: number) => void;
}

const LocationPicker: React.FC<LocationPickerProps> = ({ apiKey, onLocationChange, formList, handleAddressChange, isSubmit }) => {
    const mapRef = useRef<HTMLDivElement | null>(null);
    const [formListMod, setFormList] = useState<any>();
    const [map, setMap] = useState<google.maps.Map | null>(null);
    const [marker, setMarker] = useState<google.maps.Marker | null>(null);
    const [loaded, setLoaded] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [addressValue, setAddressValue] = useState("");

    useEffect(() => {
        if(isSubmit){
            setIsSubmitting(isSubmit);
        }
    },[isSubmit])
    useEffect(() => {
        if(formList){
            console.log(formList);
            setFormList(formList)
        }
    },[formList])

    // Load script on mount
    useEffect(() => {
        loadGoogleMapsScript(apiKey)
            .then(() => setLoaded(true))
            .catch((err) => console.error('Failed to load Google Maps:', err));
    }, [apiKey]);

    // Initialize map
    useEffect(() => {
        if (!loaded || !mapRef.current || map) return;

        const initialPosition = { lat: 13.7563, lng: 100.5018 }; // Bangkok

        const mapInstance = new google.maps.Map(mapRef.current, {
            center: initialPosition,
            zoom: 15,
        });

        const markerInstance = new google.maps.Marker({
            position: initialPosition,
            map: mapInstance,
            draggable: true,
        });

        markerInstance.addListener('dragend', () => {
            const pos = markerInstance.getPosition();
            if (pos) {

                reverseGeocode(pos.lat(), pos.lng())
                .then((address) => {
                    
                    setAddressValue(address);
                    handleAddressChange(address);
                    console.log("📍 Address:", address);
                })
                .catch((err) => {
                    console.error("❌ Error:", err);
                });
                onLocationChange(pos.lat(), pos.lng());
            }
        });

        setMap(mapInstance);
        setMarker(markerInstance);
       
        onLocationChange(initialPosition.lat, initialPosition.lng);
    }, [loaded]);

    const handleUseCurrentLocation = () => {
        if (!navigator.geolocation) {
            alert("Geolocation not supported");
            return;
        }

        navigator.geolocation.getCurrentPosition((pos) => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;

            if (map && marker) {
                const position = new google.maps.LatLng(lat, lng);
                map.setCenter(position);
                marker.setPosition(position);
                onLocationChange(lat, lng);
                reverseGeocode(lat, lng)
                .then((address) => {
                    
                    setAddressValue(address);
                    handleAddressChange(address);
                    console.log("📍 Address:", address);
                })
                .catch((err) => {
                    console.error("❌ Error:", err);
                });
            }
        });
    };
    const reverseGeocode = (lat: number, lng: number): Promise<string> => {
        return new Promise((resolve, reject) => {
            const geocoder = new google.maps.Geocoder();

            const latlng = { lat, lng };
            geocoder.geocode({ location: latlng }, (results: any, status) => {
                if (status === 'OK' && results[0]) {
                    resolve(results[0].formatted_address);
                } else {
                    reject(`Geocoder failed due to: ${status}`);
                }
            });
        });
    };
  

    return (
        <div className='location-picker-control'>
            {
                formListMod && 
                <FormControl
                className={`input-std ${isSubmitting && formListMod.is_error ? " input-error" : ""}`}
                fullWidth
            >
                <TextField
                    label="ที่อยู่"
                    variant="outlined"
                    value={addressValue}
                    onChange={(e) => 
                        {
                        setAddressValue(e.target.value);
                        if(isSubmitting){
                            setFormList({...formListMod, is_error: true});
                        }
                        handleAddressChange(e.target.value)
                    }}
                />
            </FormControl>
            }
          
            <div className='location-button-text' onClick={handleUseCurrentLocation} style={{ marginBottom: 10 }}>
                ใช้ที่อยู่ปัจจุบัน
            </div>
            <div ref={mapRef} style={{ width: '100%', height: '400px', borderRadius: 10 }} />
        </div>
    );
};

export default LocationPicker;
